import { Breakpoint } from '@/hooks/use-breakpoints';

import JobCard from '@/components/job-card';
import Link, { LinkVariant } from '@/components/link';
import Typography from '@/components/typography';

import Carousel, {
  CarouselItem,
  CarouselPerPage,
  CarouselVariant,
} from '@/features/carousel';
import useSpecialtyPageContext from '@/features/specialty-page/hooks/use-specialty-page-context';
import { routes } from '@/utils/route-utils';

type SpecialtyJobBlocksProps = {
  id: string;
};

export default function SpecialtyJobBlocks(props: SpecialtyJobBlocksProps) {
  const { specialty, specialtyPageStaticData } = useSpecialtyPageContext();

  if (!specialty || !specialtyPageStaticData) return null;

  const jobs = specialtyPageStaticData.jobBlocks[props.id];
  if (!jobs || jobs.length < 4) return null;

  const searchAllRedirectPath = routes.jobSearch({
    discipline: specialty.discipline?.apiId || undefined,
    specialty: specialty.title,
  });

  const disciplineName = specialty.discipline?.title || 'Nurse';
  const disciplineTitle = disciplineName?.match(/travel/i)
    ? disciplineName
    : `Travel ${disciplineName}`;

  const cards: CarouselItem[] = jobs.map((job) => ({
    id: job.id,
    component: <JobCard {...job} />,
  }));

  return (
    <div className='flex flex-col gap-2 rounded-2xl bg-light-purple p-8'>
      <Typography.Heading2>
        {`Popular ${specialty?.title} ${disciplineTitle} jobs`}
      </Typography.Heading2>

      <Carousel
        variant={CarouselVariant.PAGINATED}
        items={cards}
        showPagination
        perPage={{
          [Breakpoint.sm]: CarouselPerPage.ONE,
          [Breakpoint.md]: CarouselPerPage.ONE,
          [Breakpoint.lg]: CarouselPerPage.TWO,
          [Breakpoint.xl]: CarouselPerPage.ONE,
          [Breakpoint.xxl]: CarouselPerPage.TWO,
        }}
      />

      <div className='mb-4 flex items-center justify-center'>
        <Link variant={LinkVariant.PRIMARY_BUTTON} href={searchAllRedirectPath}>
          Search All {specialty.title} Jobs
        </Link>
      </div>
    </div>
  );
}
